/* TASK 3 — ΧΑΡΑΓΜΑ «Ατελιέ» v2 (owner-✓ Σ07-11β + owner-γύρος νέας session: compact opener + γωνία).
   Preview/μετρητής/χρέωση: διαβάζει ΤΟ ΕΝΑ ΣΗΜΕΙΟ config (engraving-config.liquid → JSON).
   Η ΠΡΑΓΜΑΤΙΚΗ χρέωση = server-side Cart Transform (Function) πάνω στο ΚΕΙΜΕΝΟ του property —
   εδώ μόνο ενημέρωση πελάτη. ΚΑΝΕΝΑ νέο property προ-4A: γραμματοσειρά/θέση/μέγεθος/γωνία =
   preview-only state (θα δεθούν σε properties ΜΑΖΙ με το 4A script, ίδιο go-live πακέτο). */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-engraving-config]');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var FREE_LIMIT = cfg.freeLimit || 15;

  var EUR = function (cents) {
    return (cents / 100).toLocaleString('el-GR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var countChars = function (v) { return Array.from(v.replace(/\s+/g, '')).length; };
  var tierFee = function (n) {
    if (n <= 0) return 0;
    for (var i = 0; i < cfg.tiers.length; i++) {
      var t = cfg.tiers[i];
      if (t.max === null || n <= t.max) return t.fee;
    }
    return 0;
  };
  var feeFor = function (mode, n) {
    if (mode === 'tiers') return tierFee(n);
    if (mode === 'free15') return tierFee(n - FREE_LIMIT);
    return 0;
  };

  /* ✅ Σ07-14 go-live: το πιλοτικό μαρκάρισμα _eng_pilot ΚΑΤΑΡΓΗΘΗΚΕ — τα Functions
     είναι ungated (themelidis-engraving-7) και δεν το διαβάζουν πια· το attribute
     εμφανιζόταν και στα Additional details των παραγγελιών (owner-εύρημα test order).
     Κενό no-op κρατά το call-site συμβατό. */
  var markPilotCart = function () {};

  /* Τρέχον variant (το product.js κρατά το hidden input ενημερωμένο) */
  var productData = null;
  var pj = document.querySelector('[data-product-json]');
  if (pj) { try { productData = JSON.parse(pj.textContent); } catch (e) { productData = null; } }
  var currentBaseCents = function (fallback) {
    var idInput = document.querySelector('[data-variant-id]');
    if (productData && idInput && idInput.value) {
      var vid = parseInt(idInput.value, 10);
      var vs = productData.variants || [];
      for (var i = 0; i < vs.length; i++) { if (vs[i].id === vid) return vs[i].price; }
    }
    return fallback;
  };

  document.querySelectorAll('[data-eng]').forEach(function (block) {
    var mode = block.getAttribute('data-mode');
    var baseAttr = parseInt(block.getAttribute('data-base'), 10) || 0;
    var inputs = Array.prototype.slice.call(block.querySelectorAll('[data-eng-input]'));
    if (!inputs.length) return;
    var isCanvas = block.hasAttribute('data-canvas');
    var elCount = block.querySelector('[data-count]');
    var elFee = block.querySelector('[data-fee]');
    var rowTotal = block.querySelector('[data-total-row]');
    var elTotal = block.querySelector('[data-total]');
    var body = block.querySelector('[data-eng-body]');
    var toggleBtn = block.querySelector('[data-eng-toggle]');
    var closeBtn = block.querySelector('[data-eng-close]');
    var summaryEl = block.querySelector('[data-open-summary]');
    var subEl = block.querySelector('[data-eng-sub]');
    var isOpen = function () { return !body || !body.hidden; };
    var previews = Array.prototype.slice.call(block.querySelectorAll('[data-preview]'));
    var previewFor = function (input) {
      for (var i = 0; i < previews.length; i++) {
        if (previews[i].getAttribute('data-preview-for') === input.id) return previews[i];
      }
      return previews[0] || null;
    };
    var emptyText = {};
    previews.forEach(function (p) { emptyText[p.getAttribute('data-preview-for') || '_'] = p.textContent; });

    /* 4A meta-properties (Σ07-12): κρυφά inputs _Χάραγμα Γραμματοσειρά/Θέση/Μέγεθος/Γωνία —
       ενεργά+γεμάτα ΜΟΝΟ όταν υπάρχει κείμενο (disabled = δεν υποβάλλονται καθόλου)·
       τα διαβάζει το order-to-trello script (PNG-οδηγία). Τα 7 ιερά ΑΝΕΓΓΙΧΤΑ. */
    var metaEls = {};
    Array.prototype.slice.call(block.querySelectorAll('[data-eng-meta]')).forEach(function (el) {
      metaEls[el.getAttribute('data-eng-meta')] = el;
    });
    var syncMeta = function () {
      var hasText = inputs.some(function (i) { return i.value.trim() !== ''; });
      var vals = {
        font: fontOf('_default'),
        pos: block.getAttribute('data-eng-pos') || '50,50',
        size: block.getAttribute('data-eng-size') || '',
        rot: String(rot),
      };
      Object.keys(metaEls).forEach(function (k) {
        /* per-ring meta «font:<input-id>» (βέρες Σ07-14): ενεργό/γεμάτο ΜΟΝΟ όταν
           το ΔΙΚΟ του πεδίο έχει κείμενο — αλλιώς δεν υποβάλλεται καθόλου */
        if (k.indexOf('font:') === 0) {
          var inp = document.getElementById(k.slice(5));
          var has = !!(inp && inp.value.trim() !== '');
          metaEls[k].disabled = !has;
          metaEls[k].value = has ? fontOf(k.slice(5)) : '';
        } else {
          metaEls[k].disabled = !hasText;
          metaEls[k].value = hasText ? vals[k] : '';
        }
      });
    };

    /* fonts ΑΝΑ scope (Σ07-14, εύρημα #3): κουμπί με data-font-for=<input-id> = δικό του
       scope (βέρες: καθένας τη δική του)· χωρίς data-font-for = κοινό «_default»
       (μονά προϊόντα/atelier — συμπεριφορά ΑΜΕΤΑΒΛΗΤΗ) */
    var fonts = { _default: 'callig' };
    var fontOf = function (scope) { return fonts[scope] || fonts._default; };
    var applyFont = function () {
      previews.forEach(function (p) {
        var f = fontOf(p.getAttribute('data-preview-for') || '_default');
        p.classList.remove('eng2--f-classic', 'eng2--f-callig');
        p.classList.add(f === 'classic' ? 'eng2--f-classic' : 'eng2--f-callig');
      });
      block.setAttribute('data-eng-font', fontOf('_default')); /* + κρυφό property μέσω syncMeta (4A) */
      block.querySelectorAll('[data-font]').forEach(function (b) {
        var scope = b.getAttribute('data-font-for') || '_default';
        b.classList.toggle('is-active', b.getAttribute('data-font') === fontOf(scope));
      });
      syncMeta();
      if (isCanvas) autoFitMaybe();
    };

    /* Canvas (tag «χάραγμα Canvas»): θέση/μέγεθος/ΓΩΝΙΑ ως ΠΟΣΟΣΤΑ+ΜΟΙΡΕΣ της φωτο —
       deterministic για το 4A PNG */
    var zone = block.querySelector('[data-drag-zone]');
    var dragEl = block.querySelector('[data-drag-text]');
    var sizeRange = block.querySelector('[data-size-range]');
    var rotRange = block.querySelector('[data-rot-range]');
    var pos = { x: 50, y: 50 };
    var rot = 0;
    var sizeTouched = false;

    var applyRot = function () {
      if (!dragEl) return;
      dragEl.style.transform = 'translate(-50%, -50%) rotate(' + rot + 'deg)';
      block.setAttribute('data-eng-rot', rot);
      syncMeta();
    };
    var applySize = function (pct) {
      if (!zone || !dragEl) return;
      var w = zone.getBoundingClientRect().width || 1;
      dragEl.style.fontSize = ((pct / 100) * w) + 'px';
      block.setAttribute('data-eng-size', pct);
      syncMeta();
    };
    var autoFitMaybe = function () {
      if (!isCanvas || sizeTouched || !zone || !dragEl || !isOpen()) return;
      var w = zone.getBoundingClientRect().width;
      if (!w) return; /* κρυφό πάνελ = 0 πλάτος, ξανά στο άνοιγμα */
      var probe = 8;
      applySize(probe);
      var tw = dragEl.getBoundingClientRect().width;
      if (tw > 0) {
        var target = w * 0.6;
        var pct = Math.max(4, Math.min(16, probe * (target / tw)));
        applySize(pct);
        if (sizeRange) sizeRange.value = pct;
      }
    };
    if (isCanvas && zone && dragEl) {
      var dragging = false;
      var move = function (e) {
        if (!dragging) return;
        var r = zone.getBoundingClientRect();
        pos.x = Math.min(96, Math.max(4, ((e.clientX - r.left) / r.width) * 100));
        pos.y = Math.min(92, Math.max(8, ((e.clientY - r.top) / r.height) * 100));
        dragEl.style.left = pos.x + '%';
        dragEl.style.top = pos.y + '%';
        block.setAttribute('data-eng-pos', Math.round(pos.x) + ',' + Math.round(pos.y));
        syncMeta();
      };
      dragEl.addEventListener('pointerdown', function (e) {
        dragging = true; dragEl.classList.add('is-dragging');
        dragEl.setPointerCapture(e.pointerId); e.preventDefault();
      });
      dragEl.addEventListener('pointermove', move);
      dragEl.addEventListener('pointerup', function () { dragging = false; dragEl.classList.remove('is-dragging'); });
      dragEl.addEventListener('pointercancel', function () { dragging = false; dragEl.classList.remove('is-dragging'); });
      if (sizeRange) {
        sizeRange.addEventListener('input', function () { sizeTouched = true; applySize(parseFloat(sizeRange.value)); });
      }
      var autofitBtn = block.querySelector('[data-autofit]');
      if (autofitBtn) autofitBtn.addEventListener('click', function () { sizeTouched = false; autoFitMaybe(); });
      if (rotRange) {
        rotRange.addEventListener('input', function () { rot = parseFloat(rotRange.value) || 0; applyRot(); });
      }
      var rotReset = block.querySelector('[data-rot-reset]');
      if (rotReset) rotReset.addEventListener('click', function () { rot = 0; if (rotRange) rotRange.value = 0; applyRot(); });
      applyRot();
    }

    var refresh = function () {
      var total = 0;
      var texts = [];
      inputs.forEach(function (input) {
        total += countChars(input.value);
        var t = input.value.trim();
        if (t) texts.push(t);
        var p = previewFor(input);
        if (!p) return;
        if (t) {
          p.textContent = t;
          p.classList.remove('eng2--empty');
        } else {
          p.textContent = emptyText[p.getAttribute('data-preview-for') || '_'];
          p.classList.add('eng2--empty');
        }
      });

      var fee = feeFor(mode, total);
      if (total === 0) {
        elCount.textContent = '';
        elFee.textContent = '';
      } else if (mode === 'free15') {
        if (total <= FREE_LIMIT) {
          elCount.textContent = total + ' / ' + FREE_LIMIT + ' χαρακτήρες';
          elFee.textContent = 'Δωρεάν';
        } else {
          elCount.textContent = FREE_LIMIT + ' δωρεάν + ' + (total - FREE_LIMIT) + ' έξτρα';
          elFee.textContent = '+' + fee + ' €';
        }
      } else {
        elCount.textContent = total === 1 ? '1 χαρακτήρας' : total + ' χαρακτήρες';
        elFee.textContent = fee ? '+' + fee + ' €' : 'Δωρεάν';
      }
      rowTotal.hidden = !fee;
      if (fee) elTotal.textContent = EUR(currentBaseCents(baseAttr) + fee * 100);
      /* fast-ATC: το cart.js προσθέτει τη χρέωση ΜΑΖΙ με το προϊόν (μηδέν αναμονή sync) */
      window.__engPendingFee = fee;

      /* Γ-notice (owner-✓ Σ07-13): «custom = χωρίς αντικαταβολή/επιστροφή» — ορατό
         ΜΟΝΟ όσο υπάρχει κείμενο χάραξης (μιλάει όταν αφορά, δεν αποτρέπει) */
      var notice = block.querySelector('[data-eng-notice]');
      if (notice) notice.classList.toggle('is-shown', total > 0);

      /* Σύνοψη στην κλειστή κάρτα — η κάρτα λέει πάντα την αλήθεια */
      if (summaryEl) {
        if (texts.length && !isOpen()) {
          summaryEl.innerHTML = '';
          summaryEl.appendChild(document.createTextNode(texts.join(' · ') + ' '));
          var bb = document.createElement('b');
          bb.textContent = fee ? '+' + fee + ' €' : 'Δωρεάν';
          summaryEl.appendChild(bb);
          summaryEl.hidden = false;
          if (subEl) subEl.hidden = true;
        } else {
          summaryEl.hidden = true;
          if (subEl) subEl.hidden = false;
        }
      }
      syncMeta();
      if (isCanvas) autoFitMaybe();
    };

    var setOpen = function (open) {
      if (!body) return;
      body.hidden = !open;
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { block.setAttribute('data-open', ''); } else { block.removeAttribute('data-open'); }
      refresh();
      if (open && isCanvas) requestAnimationFrame(autoFitMaybe);
    };
    if (toggleBtn && body) {
      toggleBtn.addEventListener('click', function () { setOpen(body.hidden); });
    }
    if (closeBtn && body) {
      closeBtn.addEventListener('click', function () { setOpen(false); });
    }

    block.querySelectorAll('[data-font]').forEach(function (b) {
      b.addEventListener('click', function () { fonts[b.getAttribute('data-font-for') || '_default'] = b.getAttribute('data-font'); applyFont(); });
    });
    inputs.forEach(function (input) {
      input.addEventListener('input', refresh);
      input.addEventListener('input', markPilotCart, { once: true });
      /* iOS/mobile: return = «Τέλος» → κλείνει πληκτρολόγιο· ΠΟΤΕ form-submit
         (αλλιώς το return πρόσθετε το προϊόν στο καλάθι εν αγνοία του πελάτη) */
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
      });
    });
    /* variant switch → νέο base στο «Σύνολο με χάραγμα» */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-option-radio')) refresh();
    });

    /* Σ07-14 owner-QA #10: ΒΕΡΕΣ — νούμερο ΥΠΟΧΡΕΩΤΙΚΟ και για τις δύο (η αγορά =
       κατασκευή ούτως ή άλλως, owner-matrix)· φραγή στο ΙΔΙΟ pipeline: ο form-level
       listener τρέχει ΠΡΙΝ το document-level ATC του cart.js → καλύπτει ΚΑΙ το
       buy-now (requestSubmit, INCIDENT-01 μονοπάτι). Ιερά names/values ΑΝΕΓΓΙΧΤΑ. */
    var szWoman = block.querySelector('select[name="properties[Νούμερο Γυναικείας]"]');
    var szMan = block.querySelector('select[name="properties[Νούμερο Αντρικής]"]');
    if (szWoman && szMan) {
      var atcForm = block.closest('form');
      var rowOf = function (s) { return s.closest('.eng2__duorow') || s.parentElement; };
      var missingSizes = function () {
        return [szWoman, szMan].filter(function (s) { return !s.value || s.value === 'none'; });
      };
      var clearSizeMarks = function () {
        rowOf(szWoman).classList.remove('eng2--size-missing');
        rowOf(szMan).classList.remove('eng2--size-missing');
      };
      [szWoman, szMan].forEach(function (s) { s.addEventListener('change', clearSizeMarks); });
      /* #12 (owner-QA): MODAL ειδοποίηση — πλήρες θόλωμα, κλείνει για να συνεχίσει·
         το κουμπί ανοίγει την επιλογή νούμερου της πρώτης βέρας που λείπει */
      var szNeed = document.querySelector('[data-eng-szneed]');
      var goToFirstMissing = function () {
        var miss = missingSizes();
        if (!miss.length) return;
        var row = rowOf(miss[0]);
        var trig = row.querySelector('.tj-szfield');
        if (trig) { trig.click(); } /* size-popup pipeline */
        else { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); miss[0].focus(); }
      };
      if (szNeed) {
        szNeed.querySelectorAll('[data-eng-szneed-close]').forEach(function (bx) {
          bx.addEventListener('click', function () { szNeed.close(); });
        });
        szNeed.addEventListener('click', function (e) { if (e.target === szNeed) szNeed.close(); });
        var goBtn = szNeed.querySelector('[data-eng-szneed-go]');
        if (goBtn) goBtn.addEventListener('click', function () { szNeed.close(); goToFirstMissing(); });
      }
      if (atcForm) atcForm.addEventListener('submit', function (e) {
        var miss = missingSizes();
        if (!miss.length) return;
        e.preventDefault();
        e.stopPropagation();
        miss.forEach(function (s) { rowOf(s).classList.add('eng2--size-missing'); });
        if (szNeed && szNeed.showModal) { szNeed.showModal(); }
        else { goToFirstMissing(); } /* fail-open: χωρίς dialog-support, πάμε στο πεδίο */
      });
    }

    applyFont();
    refresh();
  });

  /* Popup «Πώς χρεώνεται;» — πίνακας από ΤΟ ΙΔΙΟ config */
  var pop = document.querySelector('[data-eng-pop]');
  if (pop) {
    var table = pop.querySelector('[data-pop-table]');
    if (table) {
      var prev = 0;
      cfg.tiers.forEach(function (t) {
        var tr = document.createElement('tr');
        var label = t.max === null
          ? (prev + 1) + ' και άνω'
          : (prev + 1 === t.max ? String(t.max) : (prev + 1) + ' – ' + t.max);
        tr.innerHTML = '<td></td><td></td>';
        tr.children[0].textContent = label;
        tr.children[1].textContent = '+' + t.fee + ' €';
        table.appendChild(tr);
        prev = t.max === null ? prev : t.max;
      });
    }
    document.querySelectorAll('[data-open-pop]').forEach(function (b) {
      b.addEventListener('click', function () { pop.showModal(); });
    });
    var closeBtn = pop.querySelector('[data-close-pop]');
    if (closeBtn) closeBtn.addEventListener('click', function () { pop.close(); });
    pop.addEventListener('click', function (e) { if (e.target === pop) pop.close(); });
  }
})();
